import { Button } from "@headlessui/react";
import clsx from "clsx";

export default function HeadlessButton({
  disabled,
  className,
  children,
  theme = "primary",
  type = "button",
  ...restProps
}) {
  const secondaryThemeClasses =
    "tw-bg-white tw-text-primary-light tw-border-primary-light";

  const buttonClasses = clsx(
    theme === "none" &&
      !disabled &&
      "tw-outline-none tw-bg-transparent tw-border-none tw-text-primary-light hover:tw-text-focus hover:tw-underline",
    "tw-rounded-xl tw-outline-none tw-border-2 tw-px-2 tw-py-1",
    disabled &&
      "tw-text-disabled-text tw-border-disabled-text tw-bg-disabled-bg-light tw-cursor-not-allowed",
    disabled &&
      theme === "none" &&
      "tw-text-disabled-text tw-border-none tw-bg-transparent tw-cursor-not-allowed",
    (theme === "primary" || theme !== "secondary") &&
      !disabled &&
      theme !== "none" &&
      "tw-bg-primary-light tw-text-white tw-border-primary-light",
    theme === "secondary" && secondaryThemeClasses,
    theme === "success" && "tw-bg-success-light tw-text-white tw-border-success-light",
    className
  );

  return (
    <Button
      className={({ hover, focus }) =>
        clsx(
          buttonClasses,
          (hover || focus) &&
            !disabled &&
            theme !== "none" &&
            "tw-ring-2 tw-ring-focus tw-ring-offset-1 tw-ring-offset-white" // @TODO change ring-offset when global colors are established
        )
      }
      disabled={disabled}
      type={type}
      {...restProps}
    >
      {children}
    </Button>
  );
}
